import { LoaderService } from './../base-services/loader.service';
import { Subject } from 'rxjs';
import { List } from 'immutable';
import { InputComponent } from './../base-components/input/input/input.component';
import { DropdownPicklistComponent } from './../base-components/dropdown/dropdownPicklist/dropdownPicklist.component';
import { DropdownComponent } from './../base-components/dropdown/dropdown.component';
import { QueryParameter } from './../base-models/query-parameter';
import { BaseDataService } from './../base-services/base-data.service';
import { FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { UserService } from './../base-services/user.service';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from './base-component';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../base-services/modal.service';
import { ViewChild, Optional, Inject } from '@angular/core';
import { ElementRef } from '@angular/core';
import { MultiselectComponent } from '../base-components/dropdown/multiselect/multiselect.component';
// import { ToastrService } from 'ngx-toastr';
import { NotificationService } from '../base-services/notification-service';

export class BaseCommonComponent extends BaseComponent {
    // constructor(protected activatedRoute: ActivatedRoute,
    //             protected userService: UserService,
    //             protected baseDataService: BaseDataService,
    //             protected translateService: TranslateService,
    //             protected modalService: ModalService,
    //             protected notificationService: NotificationsService,
    //             @Optional() @Inject(LoaderService) protected loaderService?: LoaderService
    //             ){
    //     super(activatedRoute, userService);
    // }

    constructor(protected activatedRoute: ActivatedRoute,
        protected userService: UserService,
        protected baseDataService: BaseDataService,
        protected translateService: TranslateService,
        protected modalService: ModalService,
        protected toastrService: NotificationService,
        @Optional() @Inject(LoaderService) protected loaderService?: LoaderService
        ){
    super(activatedRoute, userService);
    }

    public baseFormGroup: FormGroup = new FormGroup({});
    public submitted: boolean = false;
    errorMessages = {};
    items = List();

    ItemsLoaded: Subject<boolean> = new Subject();

    get fc() { return this.baseFormGroup.controls; }

    @ViewChild('autofocus', /* TODO: add static flag */ {static: false}) autofocusElement: ElementRef;

    ngOnInit(){
        super.ngOnInit();
    }

    ngAfterViewInit(){
        this.focus();
    }

    LoadPDF(){
        this.submitted = true;
        if(this.baseFormGroup.valid || !this.baseFormGroup.invalid){
            this.translateService.get(this.modalService.ConvertPluralToSingular(this.modelData.BreadcrumbLabel))
                .subscribe(translate => {
                    this.modalService.ShowPrintDialog(translate
                        , this.modelData.MainList.EnablePrintAccountSelection)
                        .result
                            .then((value) => {
                                let reportValue: QueryParameter[] = [];
                                for(var property in this.baseFormGroup.getRawValue()){
                                    if(this.baseFormGroup.getRawValue().hasOwnProperty(property))
                                        reportValue.push(new QueryParameter(property, this.baseFormGroup.getRawValue()[property]));
                                }
                                //this.baseFormGroup.value.foreach(formGroupValue => {
                                    //reportValue.push(new QueryParameter(formGroupValue.name, formGroupValue.value));
                                //})

                                let controllerName: string;
                                let controllerMethodName: string;
                                if(this.modelData.MainList.PrintController){
                                    controllerName = this.modelData.MainList.PrintController;
                                    controllerMethodName = 'Printaj';
                                    reportValue.push(new QueryParameter("PrintMethod", this.modelData.MainList.PrintName));
                                }
                                else{
                                    controllerName = this.modelData.MainList.ModelName;
                                    controllerMethodName = this.modelData.MainList.PrintName;
                                }

                                this.baseDataService.GetFile(controllerName, controllerMethodName, {
                                    ReportPars: reportValue
                                    , WipsPars: {
                                        parReportTitle: value.Title
                                        , parReportSubtitle: value.Subtitle
                                        , parPageNoYes: value.ShowPageCount
                                        , parPageNoPosition: value.PageNoPosition
                                        , parTimeZoneInfo: 'Central Europe Standard Time'
                                        , parHeaderType: value.ReportHeaderTypes
                                        , parPageFooterType: value.ReportPageTypes
                                        , parCompanyAccounts: value.FirmaZrcs
                                        , parIzvestajId: value.TipDokumenta
                                        , parOdloziIUEregistrator: value.Eregistrator                                    }
                                }).subscribe(file => {
                                        if (file.size > 0)
                                        {
                                            let fileUrl = URL.createObjectURL(file);
                                            window.open(fileUrl);
                                        }
                                        else
                                        {
                                            this.translateService.get(['FW.ACTION.NODATA'])
                                            .subscribe(translate => {
                                                // this.notificationService.info(translate['FW.ACTION.NODATA']);
                                                this.toastrService.info(translate['FW.ACTION.NODATA'])
                                            })
                                        }
                                    }
                                    //, error => { this.submitted = false },
                                    //() => { this.submitted = false }
                                    )                
                            }, (reason) => {})
                })
        }
    }

   

    addValidatorToFc(controlName: string, controlValidator: ValidationErrors, validatorName: string, message: string){
        let controlObj = this.getControl(controlName);
        controlObj.setValidators(
            Validators.compose([controlObj.validator, controlValidator])
        )
        if(this.errorMessages[controlName] == null)
            this.errorMessages[controlName] = [];
        if(this.errorMessages[controlName].filter(validator => validator.type == validatorName).length == 0)
            this.errorMessages[controlName].push({ type: validatorName, message: message });
    }

    getControl(controlName: string){
        var splitted = controlName.split('.');
        var controlObj: any = this.baseFormGroup;

        for(let entry of splitted){
            controlObj = controlObj.controls[entry];
        }

        return controlObj;
    }

    LoadData(){
        this.submitted = true;
        if(this.baseFormGroup.valid){
            this.loaderService.ShowLoader();
            this.baseDataService.Post(this.modelData.MainList.ModelName, this.modelData.MainList.GetName, this.baseFormGroup.getRawValue(), this.modelData.MainList.ModelClass)
                .subscribe(data => {                   
                    this.items = List(data);
                    this.OnDataLoaded();
                    if (data == null || data.length == 0){
                        this.translateService.get(['FW.ACTION.NODATA'])
                        .subscribe(translate => {
                            // this.notificationService.info(translate['FW.ACTION.NODATA']);
                            this.toastrService.info(translate['FW.ACTION.NODATA']);
                        })
                    }                   
                }, error => {
                    this.ItemsLoaded.next(false);
                    this.loaderService.HideLoader();
                    throw(error);
                }, () => {
                    this.loaderService.HideLoader();
                })
        }
    }

    focus(){
        if(this.autofocusElement){
            if(this.autofocusElement instanceof DropdownComponent || this.autofocusElement instanceof DropdownPicklistComponent || this.autofocusElement instanceof InputComponent || this.autofocusElement instanceof MultiselectComponent)
                this.autofocusElement.focus();
            else
                this.autofocusElement.nativeElement.focus();
        }
    }

    OnDataLoaded(){
        this.ItemsLoaded.next(true);
    }
}